import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  removeInventoryPopOverTitle: {
    description: 'Remove inventory pop-over title',
    defaultMessage: 'Remove Inventory',
    id: 'KarvXc',
  },
  removeInventoryPopoverCancel: {
    description: 'Remove inventory pop-over cancel button',
    defaultMessage: 'Cancel',
    id: 'oPajVq',
  },
  removeInventoryRemoveButton: {
    description: 'Remove inventory pop-over add button',
    defaultMessage: 'Remove',
    id: 'hgGbZp',
  },
});
